// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"127":"78195803","146":"57d5159f","187":"96c77156","546":"7605a120","562":"cae79404","654":"92392a7c","886":"45dd86d0","919":"65691bf7"}[chunkId] + ".js";
};